import { validator } from "LIB/validate-this";
import * as rules from "LIB/validation/rules";
import { validateShippingFields } from "MODULES/PurchaseOrders/shared/validations";

export default function validate(values) {
  return validator(values, v => {
    v
      .validate("buying_store", "company_id", "contact_id", "payment_terms")
      .satisfies(rules.required);
    if (values.buyer_credit_pct <= 50.0) {
      v.validate("co_buyer_id").satisfies(rules.required);
    }

    if (values.buyer_credit_pct <= 37.5) {
      v.validate("third_buyer_id").satisfies(rules.required);
    }
  });
}

export function validateShipping(values) {
  return validator(values, v => validateShippingFields(values, v));
}



// WEBPACK FOOTER //
// ./app/modules/PurchaseOrders/components/Edit/validate.js